module.exports = "/static/media/article01.fea43ddf.jpg";